import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { milestone }: Boundaries["markMilestoneAsCompleted"]["request"],
): State {
  const index = state.findIndex((res) => res.milestone.uuid === milestone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { milestone, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { milestone, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { milestone }: Boundaries["markMilestoneAsCompleted"]["success"],
): State {
  const index = state.findIndex((res) => res.milestone.uuid === milestone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { milestone, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { milestone, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { milestone }: Boundaries["markMilestoneAsCompleted"]["failure"],
): State {
  const index = state.findIndex((res) => res.milestone.uuid === milestone.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { milestone, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { milestone, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.markMilestoneAsCompletedRequested]: handleRequest,
    [events.markMilestoneAsCompletedSucceeded]: handleSuccess,
    [events.markMilestoneAsCompletedFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
